import { Component, OnInit, OnDestroy, Input } from '@angular/core';

@Component({
  selector: 'app-date-time',
  templateUrl: './date-time.component.html',
  styleUrls: ['./date-time.component.scss'],
})
export class DateTimeComponent implements OnInit, OnDestroy {
  currentDate: string | undefined;
  currentTime: string | undefined;
  private intervalId: any;
  @Input() currentLocal: string = '';

  ngOnInit(): void {
    this.updateDateTime();
    this.intervalId = setInterval(() => this.updateDateTime(), 1000);
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private updateDateTime(): void {
    const now = new Date();

    // Formatage de la date en "Lun. 25 nov."
    const optionsDate: Intl.DateTimeFormatOptions = {
      weekday: 'short',
      day: '2-digit',
      month: 'short',
    };
    this.currentDate = now.toLocaleDateString(this.currentLocal, optionsDate);

    // Formatage de l'heure en "12h00"
    const optionsTime: Intl.DateTimeFormatOptions = {
      hour: '2-digit',
      minute: '2-digit',
    };

    if(!this.currentLocal.includes('en')){
      this.currentTime = now
      .toLocaleTimeString(this.currentLocal, optionsTime)
      .replace(':', 'h');
    }else {
      this.currentTime = now
      .toLocaleTimeString(this.currentLocal, optionsTime);
    }

  }
}
